/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { useCache, withMemo, useFlux } from 'fierry/react.old';

import Zoom from 'galax/client/zoom';
import Navigation from 'shared/client/navigation';

import Zone from 'galax/react/map/zone/zone';
import Dock from 'galax/react/map/zone/dock';
import Platform from 'galax/react/map/zone/platform';


const Component = ({ planet, navigation, ...props }) =>
{
  let collection = [];

  for (const zone of planet.getZoneCollection().getZones())
  {
    collection.push(<Zone {...props} key = {zone.getID()} zone = {zone} {...navigation.getLocationInfo(zone)} />);
  }

  for (const platform of planet.getZoneCollection().getPlatforms())
  {
    collection.push(<Platform {...props} key = {platform.getID()} platform = {platform} {...navigation.getLocationInfo(platform)} />);
  }

  for (const sector of planet.getSectors().getAll())
  {
    for (const dock of sector.getNeighbors().getDocks())
    {
      collection.push(<Dock {...props} key = {dock.getID()} dock = {dock} {...navigation.getLocationInfo(dock)} />);
    }
  }

  return collection;
}


export default withMemo(({ currentUserID, ...props }) =>
{
  const [ navigation, zoom ] = useFlux(Navigation, Zoom);

  const geometry = props.planet.getGeometry(zoom.getValue());

  return <Component {...props} navigation = {navigation} geometry = {geometry} currentUser = {props.planet.getUser(currentUserID)} />;
});
